import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { SBHorizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelM } from '@sorare/core/src/atoms/typography';
import { VerifyPhoneNumber } from '@sorare/core/src/components/user/VerifyPhoneNumber';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { Warning } from '@sorare/core/src/contexts/intl/Warning';
import { glossary } from '@sorare/core/src/lib/glossary';

export const VerifyPhoneBanner = () => {
  const [showVerifyPhone, setShowVerifyPhone] = useState(false);
  const { currentUser } = useCurrentUserContext();

  if (currentUser?.phoneNumberVerified) return null;

  return (
    <>
      <ButtonBase onClick={() => setShowVerifyPhone(true)}>
        <Warning variant="yellow">
          <SBHorizontal>
            <LabelM>
              <FontAwesomeIcon icon={faExclamationTriangle} />{' '}
              <FormattedMessage defaultMessage="You need to verify your phone number to validate the referral." />
            </LabelM>
            <Button
              asSpan
              color="secondary"
              size="small"
              onClick={() => setShowVerifyPhone(true)}
            >
              <FormattedMessage {...glossary.verify} />
            </Button>
          </SBHorizontal>
        </Warning>
      </ButtonBase>
      {!!showVerifyPhone && (
        <VerifyPhoneNumber onCancel={() => setShowVerifyPhone(false)} />
      )}
    </>
  );
};
